import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useState, useContext } from 'react';
import AuthContext from '../context/AuthContext';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

export default function SendMessageComponent(props) {
    const { backendUrl, authTokens, logoutUser } = useContext(AuthContext);
    const [message, setMessage] = useState('');
    const [messageSent, setMessageSent] = useState(false)

    const handleClickOpen = () => {
        props.setOpen(true);
    };

    const handleClose = () => {
        props.setOpen(false);
    };

    const handleMessageChange = event => {
        setMessage(event.target.value);
    };

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setMessageSent(false);
      };

    let sendMessageSubmit = async (e) => {
        console.log('sending ' + message);
        const response = await fetch(backendUrl + 'api/send-message/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({ text: message, target_type: 'child', target_id: props.studentId })
        }).catch((error) => {
            // Your error is here!
            console.log(error)
        });;

        if (response.status === 200) {
            console.log('Sent!');
            props.setOpen(false);
            setMessageSent(true);
        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }

    

    return (
        <>
            <Snackbar
                open={messageSent}
                autoHideDuration={20000}
                onClose={handleAlertClose}
            >
                <MuiAlert variant="filled" elevation={6} sx={{ width: '100%' }} severity='success'>Message sent!</MuiAlert>
            </Snackbar>
            <Dialog open={props.open} onClose={handleClose}>
                <DialogTitle>Message to parents of {props.name}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        This message will be sent to all parents of the child
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Message"
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={handleMessageChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={sendMessageSubmit}>Send</Button>
                    <Button onClick={handleClose}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}